/* sugar:assets/popup-cards.js@2.0.0 */
/*
  Popup Cards: the label row inside each card's popup. The row is a button whose
  aria-expanded the stylesheet reads to open the panel under it, so this file only
  flips that state. One listener on the document serves every row on the page, the
  popups included once popup.js has moved them to <body>.

  It also gets each popup's pictures ready before the popup opens. A closed popup's
  pictures wait for the popup to open before they even start downloading, so a popup
  used to open on an empty header. Once the page has loaded and a
  section's cards come within a screen of view, every header picture in it switches to
  loading now; hovering, focusing or pressing a card's link starts that card's pictures
  at once; and opening a popup starts its label picture, before the label row is opened.
*/
(function () {
  'use strict';

  if (window.__sugarPopupCards) return;
  window.__sugarPopupCards = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-popup-cards-toggle]');
    if (!btn) return;
    btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  });

  // A closed popup's pictures carry their address in data-pd-src / data-pd-srcset (popup-dialog
  // snippet) until popup.js hands it back on open; hand it back early, the same way.
  function load(img) {
    if (!img) return;
    if (img.dataset.pdSrcset) { img.setAttribute('srcset', img.dataset.pdSrcset); img.removeAttribute('data-pd-srcset'); }
    if (img.dataset.pdSrc) { img.setAttribute('src', img.dataset.pdSrc); img.removeAttribute('data-pd-src'); }
    if (img.loading === 'lazy') img.loading = 'eager';
  }

  // A card's popup sits inside the card until its first open, then popup.js moves it to <body>.
  function popupOf(link) {
    var id = link.getAttribute('data-popup-open');
    return id ? document.querySelector('[data-popup-dialog="' + id + '"]') : null;
  }

  function warmCard(link, withLabel) {
    var dialog = popupOf(link);
    if (!dialog) return;
    load(dialog.querySelector('.sugar-popup-cards__pop-img'));
    if (withLabel) load(dialog.querySelector('.sugar-popup-cards__label-img'));
  }

  function intent(e) {
    var link = e.target.closest && e.target.closest('.sugar-popup-cards__link');
    if (link) warmCard(link, e.type === 'click');
  }
  document.addEventListener('pointerover', intent, { passive: true });
  document.addEventListener('focusin', intent);
  document.addEventListener('touchstart', intent, { passive: true });
  document.addEventListener('click', intent, true); // capture: popup.js stops the click at the link

  function watch() {
    var lists = document.querySelectorAll('.sugar-popup-cards');
    if (!lists.length) return;
    var warmList = function (root) {
      Array.prototype.forEach.call(root.querySelectorAll('.sugar-popup-cards__link'), function (link) {
        warmCard(link, false);
      });
    };
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(lists, warmList);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        warmList(entry.target);
      });
    }, { rootMargin: '100% 0px' });
    Array.prototype.forEach.call(lists, function (root) { io.observe(root); });
  }

  // After load, so nothing here competes with the pictures at the top of the page.
  if (document.readyState === 'complete') watch();
  else window.addEventListener('load', watch, { once: true });
})();
